export default __webpack_public_path__ + "static/media/MomentoHeader.35eea146.png";